import { Grid, Paper } from '@mui/material';
import { useSnackbar } from 'notistack';
import { SubmitHandler } from 'react-hook-form';
import { useMutation } from 'react-query';
import { useNavigate, useParams } from 'react-router';
import * as dashboardApi from '../../api/app/dashboardsApi';
import { AssetFullPathHeader } from '../../components/core/AssetFullPathHeader/AssetFullPathHeader';
import { PageContent } from '../../components/core/PageContent/PageContent';
import { AssetDetailTabValues } from '../../types/app/asset.types';
import {
  AssetDashboardType,
  DashboardInputs,
  DashboardTypes,
} from '../../types/app/dashboards.types';
import { dictionary } from '../../utils/core/dictionary';
import { convertDataFromInputToCreateRequest } from '../../utils/core/functions/dashboard.functions';
import { paths } from '../../utils/core/routes';
import { DashboardForm } from './DashboardForm';
import { useStyles } from './DashboardForm.styles';

export function DashboardCreate() {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const { parentId } = useParams();
  const navigate = useNavigate();
  const { mutate: mutateCreateDashboard } = useMutation(dashboardApi.createDashboard);
  const { mutate: mutateCreateAssetDashboard } = useMutation(
    dashboardApi.grafanaCreateDashboardForAsset,
  );

  const handleOnSubmit: SubmitHandler<DashboardInputs> = (data: DashboardInputs) => {
    const requestData = convertDataFromInputToCreateRequest({
      ...data,
      assetId: Number(parentId),
      type: data.assetType ? data.assetType : data.type,
      assetType: undefined,
    });
    if (data.type === DashboardTypes.MAIN_DASHBOARD) {
      requestData.url = '';
    }
    data.assetType && data.assetType !== AssetDashboardType.URL
      ? mutateCreateAssetDashboard(
          { ...requestData },
          {
            onSuccess: () => {
              enqueueSnackbar(dictionary.DASHBOARD_CREATED, { variant: 'success' });
              navigate(`${paths.ASSETS_DETAIL}/${parentId}`, {
                state: {
                  tabValue: AssetDetailTabValues.DASHBOARD,
                },
              });
            },
            onError: (result: any) => {
              enqueueSnackbar(`${result}`, { variant: 'error' });
            },
          },
        )
      : mutateCreateDashboard(
          {
            ...requestData,
            type: data.type === AssetDashboardType.URL ? DashboardTypes.GRAFANA : data.type,
          },
          {
            onSuccess: () => {
              enqueueSnackbar(dictionary.DASHBOARD_CREATED, { variant: 'success' });
              navigate(`${paths.ASSETS_DETAIL}/${parentId}`, {
                state: {
                  tabValue: AssetDetailTabValues.DASHBOARD,
                },
              });
            },
            onError: (result: any) => {
              enqueueSnackbar(`${result}`, { variant: 'error' });
            },
          },
        );
  };

  return (
    <>
      <AssetFullPathHeader finalTitle={dictionary.DASHBOARD_CREATE} parentId={Number(parentId)} />
      <PageContent>
        <Grid container spacing={1}>
          <Grid item xs={12} md={8} lg={4}>
            <Paper className={classes.paper}>
              <DashboardForm
                onSubmit={handleOnSubmit}
                onBack={() => navigate(`${paths.ASSETS_DETAIL}/${parentId}`)}
              />
            </Paper>
          </Grid>
        </Grid>
      </PageContent>
    </>
  );
}
